import { Component } from "@angular/core";

@Component({
  selector: "app-knowledge-list-container-page",
  templateUrl: "./knowledge-list-container-page.component.html",
  styleUrls: ["./knowledge-list-container-page.component.scss"],
})
export class KnowledgeListContainerPageComponent {}
